import { render, staticRenderFns } from "./treeBody.vue?vue&type=template&id=1327ecca&scoped=true&"
import script from "./treeBody.vue?vue&type=script&lang=js&"
export * from "./treeBody.vue?vue&type=script&lang=js&"
import style0 from "./treeBody.vue?vue&type=style&index=0&id=1327ecca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327ecca",
  null
  
)

export default component.exports